import randomBackground from '../data/randomBackground.json';

export default class BackgroundImageService {
    static getRandomBackgroundImage() {
        let number = Math.floor(Math.random() * 12) + 1;
        return randomBackground.background_images[number];
    }
}